import $server from './serverProxy';

const PARTS_DATA = 'data/parts.json';
const MONITORS_DATA = 'data/monitors.json';
const STRINGS_DATA_PREFIX = 'strings/strings-';
const LICENSE_DATA = 'license.html';
const LICENSES_DATA = 'data/licenses.json';


const get = (route) => {
  // make sure cache is used properly here
  return $server.get(route);
};

const fetchPartsData = () => {
  return get(PARTS_DATA).then(response => response.json());
};

const fetchMonitorsData = () => {
  return get(MONITORS_DATA).then(response => response.json());
};

const fetchLanguageStringData = (languageCode) => {
  return get(`${STRINGS_DATA_PREFIX}${languageCode}.json`).then(response => response.json());
};

const fetchLicenseText = () => {
  return get(LICENSE_DATA).then(response => response.text());
};

const fetchLicensesData = () => {
  return get(LICENSES_DATA).then(response => response.json());
};

const postWorkbook = (wb) => {
  /*
  const filename = Math.random().toString(36).substr(2);
  const formData = new FormData();
  formData.append('upfile', 'sheet'); // <-- server expects `file` to hold name
  formData.append('data', wb); // <-- `data` holds the base64-encoded data
  return this.server.post('sheets', formData).then(response => response.text()).then(msg => console.log('BACK:', msg));
   */
  return $server.post('sheets', {
    method: 'POST',
    body: JSON.stringify({
      xlsx: wb
    })
  }).then(response => response.text())
    .then((filename) => {
      window.open($server.makeAbsoluteUrl(`sheets/${filename}`));
    });
};


export default {
  fetchPartsData,
  fetchMonitorsData,
  fetchLanguageStringData,
  fetchLicenseText,
  fetchLicensesData,
  postWorkbook,
};
